<template>
  <b-form-group>
    <label for="date_name">{{ content.key | capitalize }}</label>
    <sup v-if="content.required" class="text-danger required-css">
      <i class="fa fa-asterisk"></i>
    </sup>
    <span v-if="content.current_value">
      <span v-if="content.date_format"><i>({{content.date_format}})</i></span>
      <span v-if="content.edited" class="badge" :style="{ color: '#FFFFFF', backgroundColor: '#170c9e' }" :title="$t('FORMS.CON_SCORE')">100</span>
      <span v-else class="badge" :style="{ backgroundColor: content.color_code }" :title="$t('FORMS.CON_SCORE')">{{ Math.round(content.confidence * 100) }}</span>
    </span>
    <span v-if="content.edited" class="badge badge-edited"><i class="fa fa-check" aria-hidden="true"></i> Edited</span>
    <span v-if="content.is_auto_correct && autoCorrectFlag" class="badge badge-auto-corrected"><i class="fa fa-check" aria-hidden="true"></i> Auto-Corrected</span>
    <span v-else-if="content.auto_correct_enable && autoCorrectFlag" class="badge badge-auto_correct_enable"><i class="fa fa-check" aria-hidden="true"></i> Auto-Correct-Enable</span>
    <date-picker id="date_name" v-model="date" @input="handleDateInput" value-type="format" lang="en" format="MM-DD-YYYY" append-to-body :clearable="false" width="100%"></date-picker>
  </b-form-group>
</template>
<script>
import DatePicker from 'vue2-datepicker'
export default {
  props: ['content', 'imgBase', 'imgUrl'],
  name: 'date-field',
  components: { 'date-picker': DatePicker },
  data () {
    return {
      date: this.content.current_value
    }
  },
  methods: {
    handleDateInput (value) {
      let newValue = new Date(value).getTime()
      let currentValue = new Date(this.content.current_value).getTime()
      if (newValue !== currentValue) {
        this.content.current_value = value
        this.$emit('update', {content: this.content, newValue: value})
      }
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/process/dateField.vue